import Vue from 'vue';
import App from './App';
import VueResource from 'vue-resource';
import VueMaterial from 'vue-material';
import VueRouter   from 'vue-router';
import VueCookie   from 'vue-cookie';
import VueMeta     from 'vue-meta';
import AsyncComputed from 'vue-async-computed';
import VeeValidate   from 'vee-validate';
import ValidationMessages from 'vee-validate/dist/locale/ru';
import ClickOutside from 'vue-click-outside'
import Datetime   from 'vue-datetime';
import Moment     from 'moment-timezone';
import Index      from '@/components/Index';
import MoneyToStr from './assets/js/moneytostr.js';
import LoaderOverlay from './directives/LoaderOverlay/index.js';
import * as Sentry from "@sentry/vue";
import { sync }  from 'vuex-router-sync';
import { store } from './store';
//import { pusher, channel } from './pusher';
import ZPusher from './zpusher';
import { helpers }  from "./helpers";
import { Settings } from 'luxon';
import { Integrations } from "@sentry/tracing";
import errorHandler from './helpers/errorHandler';
import './mixins/strwidth'
import config from './config';
import {
  routes     as ModuleRoutes,
  stores     as ModuleStores,
  menus      as ModuleMenus,
  pusher     as ModulePusher,
  toolbars   as ModuleToolbars,
  dashboards as ModuleDashboards
} from '@/modules';

import 'vue-datetime/dist/vue-datetime.css';
import 'vue-material/dist/vue-material.min.css';

require('@fortawesome/fontawesome-free/js/all');
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { } from '@fortawesome/free-regular-svg-icons';
import {
  faCheck, faTimes, faXmark, faPen, faTrash, faDolly, faCircleUser, faGear, faEnvelope, faPrint, faArrowsRotate, faTrashArrowUp
} from '@fortawesome/free-solid-svg-icons';
library.add(faCheck, faTimes, faXmark, faPen, faTrash, faDolly, faCircleUser, faGear, faEnvelope, faPrint, faArrowsRotate, faTrashArrowUp);
const VueInputMask = require('vue-inputmask').default;

Settings.defaultLocale = 'ru';
Moment.locale('ru');
Moment.tz.setDefault('Asia/Vladivostok');
Vue.prototype.defaultTimezone = 'Asia/Vladivostok';
Vue.prototype.userTimezone = Moment.tz.guess(true);

Vue.prototype.moment = Moment;
Vue.prototype.config = config;
Vue.prototype.MoneyToStr = MoneyToStr;
Vue.prototype.helpers    = helpers;
Vue.prototype.config.egrulUrl = 'https://egrul.nalog.ru/index.html';

Vue.component('fa-icon', FontAwesomeIcon);

const getBuildInfo = () => {
  const packageJSON = require('./../package.json');
  if (packageJSON && packageJSON.version) Vue.prototype.appVersion = packageJSON.version;
  else Vue.prototype.appVersion = 'Не определена';
  
  if (document && document.currentScript) {
    let scriptPath = document.currentScript.getAttribute('src').split('/app.');
    if (scriptPath[1]) Vue.prototype.appHash = scriptPath[1];
    else Vue.prototype.appHash = 'Не определён';
  } else Vue.prototype.appHash = 'Не определён';
};
getBuildInfo();


if (config.sentry && config.sentry.dsn && config.sentry.app) {
  Sentry.init({
    Vue,
    dsn: config.sentry.dsn,
    integrations: [new Integrations.BrowserTracing()],
    initialScope: {tags: {'app': config.sentry.app}},
    tracesSampleRate: 1.0,
    release: Vue.prototype.appVersion,
  });
  Sentry.setContext("app", {name: config.sentry.app, release: Vue.prototype.appVersion, hash: Vue.prototype.appHash});
  Vue.prototype.Sentry = Sentry;
}

ValidationMessages.messages.integer = (fieldName, params, data) => `Поле ${fieldName} должно быть целочисленным.`;

LoaderOverlay({store: store});
Vue.directive('click-outside', ClickOutside);
Vue.use(VueResource);
Vue.use(VueMaterial);
Vue.use(VueRouter);
Vue.use(VueCookie);
Vue.use(VueMeta);
Vue.use(AsyncComputed);
Vue.use(Datetime);
Vue.use(VeeValidate, {
  locale: 'ru',
  events: 'input|change|blur',
  dictionary: {
    ru: ValidationMessages
  }
});
Vue.use(VueInputMask);

Vue.http.headers.common['Authorization'] = localStorage.getItem('id_token');
Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*';
Vue.http.headers.common['X-Requested-With'] = "XMLHttpRequest";
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.http.options.emulateHTTP = true;

let router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'router-link-active active',
  settingsLinkActiveClass: 'router-link-active active setting-link-active',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index
  }].concat(ModuleRoutes)
});

const unsync = sync(store, router);
let components = {App};

//добавляем все компоненты меню из модулей
for (let i in ModuleMenus) Object.assign(components, ModuleMenus[i])
//добавляем все компоненты верхней панели из модулей
for (let i in ModuleToolbars) Object.assign(components, ModuleToolbars[i])

errorHandler.listen(config, Vue.prototype);

new Vue({
  el: '#app',
  router,
  store,
  template: '<app/>',
  components: components,
  helpers: helpers,
  data() {
    return {
      menus: ModuleMenus,
      toolbars: ModuleToolbars,
      dashboards: ModuleDashboards,
      colors: ['#2196f3', '#FF5252', '#FAFAFA', '#009688', '#000000', '#FFFFFF'],
      loaded: false
    }
  },
  created() {
    this.init();
  },
  computed: {
    endpoint() {
      return this.$store.state.endpoint;
    },
    staticEndpoint() {
      return this.$store.state.staticEndpoint;
    },
    currentUser() {
      return this.$store.state.users.current;
    },
  },
  watch: {
    '$route.name'(current, prev) {
      if (current != 'Login' && current != 'Logout') this.checkWebAccess();
    }
  },
  methods: {
    init() {
      this.rules();
      this.checkWebAccess().then(user => {
        if (!user || !user.id) return;
        this.inactivityListener();
        this.zPushListener();
        this.Sentry.setUser({
          id:    (user && user.id)    ? user.id    : null,
          email: (user && user.email) ? user.email : null,
          username:   (user && user.login) ? user.login : null,
          ip_address: (user && user.ip)    ? user.ip    : null
        })
      }).finally(() => (this.loaded = true));
    },
    inactivityListener() {
      this.helpers.inactivity.listen((60 * 60 * 8), () => this.$store.dispatch('users/authReset'));
    },
    /* Старый метод для работы с pusher.js
    pushListener() {
      //обработчики событий pusher
      channel.bind_global((event, data) => {
        for (var module in ModulePusher) {
          if (ModulePusher.hasOwnProperty(module)) {
            let moduleEventHandlers = ModulePusher[module];
            if (moduleEventHandlers && typeof moduleEventHandlers[event] === 'function') {
              moduleEventHandlers[event](data, this);
            }
          }
        }
      });
    },
    */
    zPushListener() {
      if (!ZPusher) return;
      ZPusher.on('open', async () => {
        const onEvent = await ZPusher.subscribe('broadcast').then(onEvent => onEvent, () => this.$store.commit('showSnackbar', ['Ошибка соединения с Pusher сервером.', 6000, 'error']));
        if (!onEvent) return;

        Object.values(ModulePusher).filter(events => !!events).map(events => Object.keys(events).map(event => onEvent(event, data => events[event](data, this))));
      });

      ZPusher.connect();
    },    
    toggleMenu(e) {
      let arrow = e.srcElement || e.target;
      let link  = arrow.parentElement;
      let li    = link.parentElement;

      if (link) link.classList.toggle('active');
      if (li)   li.classList.toggle('active');
    },
    isAuth() {
      if (this.currentUser && this.currentUser.id) {
        return new Promise(resolve => resolve(this.currentUser));
      } else {
        if (this.awaitUser) return new Promise(resolve => {
          const interval = setInterval(() => {
            if (!this.awaitUser) {
              clearInterval(interval);
              resolve(this.currentUser);
            }
          }, 100);
        });

        this.awaitUser = true;
        return this.$store.dispatch('users/getCurrentUser').finally(r => {
          this.awaitUser = false;
          return r;
        });
      }
    },
    checkWebAccess() {
      return new Promise(async resolve => {
        if (this.$route.name == 'Login' || this.$route.name == 'Logout') return resolve(false);
        let user = await this.isAuth();

        let canWebAccess = null;
        if (user && user.groups) canWebAccess = user.groups.find(item => (["agent", "managers", "administrators", "storekeepers"].indexOf(item.code)+1));
        if (canWebAccess) return resolve(user);
        
        this.$store.commit('showSnackbar', ['Требуется авторизация либо пользователь не имеет доступа к Веб-интерфейсу', 6000, 'error']);
        this.$store.dispatch('users/logout').then(() => {
          this.$router.push({name: 'Login'});
          return resolve(false);
        });
      });
    },
    rules() {
      this.$validator.extend('passport', {
        getMessage: field => 'Значение ' + field + ' должно быть корректным паспортом.',
        validate: (value, [testProp]) => {
          if (!value) return false;
          value = value.replace(/\D/g, "");
          let length = (value.length == 10);
          if (!length) return length;
  
          let year = value.substring(2, 4),
              number = value.substring(4),
              currentYear = new Date().getFullYear().toString().substring(2, 4);

          if (parseInt(number) < 101 || parseInt(number) > 999999) return false;
          
          if ((parseInt(year) >= 97 && parseInt(year) <= 99) || (parseInt(year) >= 0 && parseInt(year) <= parseInt(currentYear))) return true;
          else return false;
        }
      });
    }
  }
});


// WEBPACK FOOTER //
// ./src/main.js